import { PrimaryButton } from "@rpforms/shared/build/components/layout/Button";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useForm from "react-hook-form";
import { useSelector } from "react-redux";
import { EntitySelect } from "../entities/select";

interface IModalAddress {
    editor: IEditor;
    next: (payload) => {};
}

export const ModalFormEntry = ({ editor, next }: IModalAddress) => {
    const preload = editor.config.preload || {};
    const isInvoiceForm = preload?.form?.name === "000_Rechnung";
    const preloadBuyerOrderReference = preload?.buyer_order_reference_number || "";
    const preloadBt13BuyerOrderReference =
        preload?.zugferd_bt_fields?.bt_13_buyer_order_reference || "";

    const [override, setOverride] = useState(false);
    const [entity, setEntity] = useState<any>();
    const [buyerOrderReference, setBuyerOrderReference] = useState(
        preloadBt13BuyerOrderReference || preloadBuyerOrderReference || ""
    );
    const entities = useSelector<any, any[]>((state) => state.entities.entities);

    useEffect(() => {
        setBuyerOrderReference(
            preloadBt13BuyerOrderReference || preloadBuyerOrderReference || ""
        );
    }, [preloadBt13BuyerOrderReference, preloadBuyerOrderReference]);

    const { handleSubmit } = useForm();
    const onSubmit = () => {
        const payload: any = {
            ...preload,
            entity,
            override,
        };

        if (isInvoiceForm) {
            payload.buyer_order_reference_number = buyerOrderReference || "";
            payload.zugferd_bt_fields = {
                ...(preload?.zugferd_bt_fields || {}),
                bt_13_buyer_order_reference: buyerOrderReference || "",
            };
        }

        next(payload);
    };

    const changeEntity = (selectedEntity) => {
        setEntity(entities.find((e) => e.id === selectedEntity.value));
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
                <Modal.Title>Protokoll erstellen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Objekt
                <EntitySelect onSelect={changeEntity}></EntitySelect>
                
                {isInvoiceForm && (
                    <div style={{ marginTop: '15px' }}>
                        <label htmlFor="buyerOrderReference">
                            Bestellnummer (BuyerOrderReferencedDocument, optional)
                        </label>
                        <input
                            id="buyerOrderReference"
                            type="text"
                            className="form-control"
                            placeholder="Bestellnummer eingeben..."
                            value={buyerOrderReference}
                            onChange={(e) => setBuyerOrderReference(e.target.value)}
                        />
                    </div>
                )}
                
                <label htmlFor={"override"} style={{ marginTop: '15px', display: 'block' }}>
                    <input
                        id={"override"}
                        type={"checkbox"}
                        name={"override"}
                        checked={override}
                        onChange={() => setOverride(!override)}
                    />{" "}
                    Altes Protokoll überschreiben
                </label>
            </Modal.Body>
            <Modal.Footer>
                <PrimaryButton type={"submit"}>{"Speichern"}</PrimaryButton>
            </Modal.Footer>
        </form>
    );
};
